import React from 'react'
import { navigate } from '../../../utils/navigation'

import './styles.css'

function WalkthroughBanner({ isMobile, displace }) {
  return (
    <div
      id="WalkthroughBanner"
      className={`${isMobile ? 'is-mobile-verify' : ''} ${displace ? 'displace' : ''}`}
    >
      <div className="wrapper-verify-banner">
        <span className="info">
          <b>
            Watch our 2-minute walkthrough video to get the most out of Stan
            Winston School.
          </b>
        </span>
        <button
          className="btn -thin -orange verify-button"
          aria-label="Click this button to go watch an explanatory video"
          onClick={() => navigate('/walkthrough')}
          type="button"
        >
          <span>Watch</span>
        </button>
      </div>
    </div>
  )
}

export default WalkthroughBanner
